module.exports = __webpack_public_path__ + "static/malen-de8846a86beb60c8a9d2e625ed3c13c1.jpg";